import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectCustomerDisconnects(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  const disconnectLogs = logs.filter(
    (log) =>
      log.EventType === 'ContactFlowEvent' &&
      (log.LogData.Content?.toLowerCase().includes('disconnect') ||
        log.LogData.Content?.toLowerCase().includes('hang up') ||
        log.LogData.FlowOutcome === 'Disconnect')
  );

  // Check if disconnect happened early in the call (within first 2 minutes)
  if (disconnectLogs.length > 0 && logs.length > 0) {
    const callStart = new Date(logs[0].AbsoluteTime);
    const disconnectTime = new Date(disconnectLogs[0].AbsoluteTime);
    const callDuration = disconnectTime.getTime() - callStart.getTime();
    const durationSeconds = callDuration / 1000;

    if (durationSeconds < 120) {
      // Less than 2 minutes
      const originalIndex = logs.indexOf(disconnectLogs[0]);
      problems.push({
        id: generateId(),
        type: ProblemType.CUSTOMER_DISCONNECT,
        severity: ProblemSeverity.MEDIUM,
        title: 'Early Customer Disconnect',
        description: `Customer disconnected after only ${Math.round(durationSeconds)} seconds`,
        timestamp: disconnectLogs[0].AbsoluteTime,
        source: 'IVR_LOG',
        relatedData: { callDuration: durationSeconds, log: disconnectLogs[0] },
        suggestions: [
          'Review initial prompts for clarity',
          'Check for technical issues during call setup',
          'Consider if queue wait time contributed to disconnect'
        ],
        index: originalIndex >= 0 ? originalIndex : undefined
      });
    }
  }

  return problems;
}
